import type { FC } from 'react'

import type { Filter as AgeOfReferenceFilterT } from '@/components/Filter/AgeOfReferenceFilter'
import AgeOfReferenceFilter, {
  DEFAULT_FILTER as DEFAULT_AGE_OF_REFERENCE_FILTER,
} from '@/components/Filter/AgeOfReferenceFilter'
import type { Filter as CifasFilterT } from '@/components/Filter/CifasFilter'
import CifasFilter, {
  DEFAULT_FILTER as DEFAULT_CIFAS_FILTER,
} from '@/components/Filter/CifasFilter'
import FraudSettingsFilter, {
  DEFAULT_FILTER as DEFAULT_FRAUD_SETTINGS_FILTER,
} from '@/components/Filter/FraudSettingsFilter'
import type { Filter as FraudSettingsFilterT } from '@/components/Filter/FraudSettingsFilter'
import Section from '@/components/Filter/Section'
import SectionBreak from '@/components/Filter/SectionBreak'
import SLAFilter, {
  DEFAULT_FILTER as DEFAULT_SLA_FILTER,
} from '@/components/Filter/SLAFilter'
import type { Filter as SLAFilterT } from '@/components/Filter/SLAFilter'
import TenancyStartDateFilter, {
  DEFAULT_FILTER as DEFAULT_TENANCY_START_DATE_FILTER,
} from '@/components/Filter/TenancyStartDateFilter'
import type { Filter as TenancyStartDateFilterT } from '@/components/Filter/TenancyStartDateFilter'
import ScrollContainer from '@/components/ScollContainer'

export interface FilterT {
  fraudSettings: FraudSettingsFilterT
  sla: SLAFilterT
  ageOfReference: AgeOfReferenceFilterT
  cifas: CifasFilterT
  tenancyStartDate: TenancyStartDateFilterT
}

export const DEFAULT_FILTER: FilterT = {
  fraudSettings: DEFAULT_FRAUD_SETTINGS_FILTER,
  sla: DEFAULT_SLA_FILTER,
  ageOfReference: DEFAULT_AGE_OF_REFERENCE_FILTER,
  cifas: DEFAULT_CIFAS_FILTER,
  tenancyStartDate: DEFAULT_TENANCY_START_DATE_FILTER,
}

export interface Props {
  filter: FilterT
  onChangeFilter: (filter: FilterT) => void
}

const Filter: FC<Props> = ({ filter, onChangeFilter }) => (
  <ScrollContainer>
    <Section>
      <FraudSettingsFilter
        filter={filter.fraudSettings}
        onChangeFilter={fraudSettingsFilter =>
          onChangeFilter({
            ...filter,
            fraudSettings: fraudSettingsFilter,
          })
        }
      />
    </Section>
    <SectionBreak />
    <Section title="SLA">
      <SLAFilter
        filter={filter.sla}
        onChangeFilter={newFilter => onChangeFilter({ ...filter, sla: newFilter })}
      />
    </Section>
    <SectionBreak />
    <Section title="Age of reference">
      <AgeOfReferenceFilter
        filter={filter.ageOfReference}
        onChangeFilter={newFilter =>
          onChangeFilter({ ...filter, ageOfReference: newFilter })
        }
      />
    </Section>
    <SectionBreak />
    <Section title="CIFAS">
      <CifasFilter
        filter={filter.cifas}
        onChangeFilter={newFilter => onChangeFilter({ ...filter, cifas: newFilter })}
      />
    </Section>
    <SectionBreak />
    <Section title="Tenancy move in date">
      <TenancyStartDateFilter
        filter={filter.tenancyStartDate}
        onChangeFilter={newFilter =>
          onChangeFilter({ ...filter, tenancyStartDate: newFilter })
        }
      />
    </Section>
  </ScrollContainer>
)

export default Filter
